export const chat = {
  welcomeMessage: "Hi! I'm Victor's assistant. I can help with services, skills, projects, or contact. How can I help?",
  messagePlaceholder: "Type a message...",
  thinking: "Thinking...",
  openChat: "Chat with my AI twin",
  typingStatus: "AI thinking...",
  tabs: {
    info: "AI Assistant",
    email: "Contact Form"
  },
  modes: {
    info: {
      welcome: {
        title: "Welcome to my AI Assistant",
        description: "Feel free to ask me anything about Victor's skills, services, or portfolio."
      }
    },
    email: {
      title: "Send me a message",
      description: "Fill out the form below to get in touch directly with Victor.",
      form: {
        name: "Your name",
        email: "Your email",
        message: "Your message",
        send: "Send",
        sending: "Sending...",
        success: "Message sent successfully!",
        error: "Failed to send message. Please try again."
      }
    }
  }
}; 